// @ts-check
import React from "react";
import PropTypes from "prop-types";
import Title from "../Title/title";

const TitleTop = props => {
    return <div className="title-top">{props.Title && <Title {...props} />}</div>;
};

TitleTop.propTypes = {
    Title: PropTypes.string,
    IsTitleH1: PropTypes.bool
};

export default TitleTop;
